import React from 'react'
import { Box, TextField, Typography, Card, CardContent, useTheme, useMediaQuery } from '@mui/material'

interface RequiredCommentsCardProps {
  documentNumberInputRef: React.RefObject<HTMLInputElement>
  documentNumber: string
  observations: string
  onDocumentNumberChange: (value: string) => void
  onObservationsChange: (value: string) => void
}

export const RequiredCommentsCard: React.FC<RequiredCommentsCardProps> = ({
  documentNumberInputRef,
  documentNumber,
  observations,
  onDocumentNumberChange,
  onObservationsChange
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box mb={3}>
      <Card
        variant="outlined"
        style={{
          border: `2px solid ${theme.palette.warning.main}`,
          backgroundColor: theme.palette.background.paper
        }}
      >
        <CardContent>
          <Typography variant="h6" gutterBottom style={{ color: theme.palette.warning.main }}>
            Información Requerida
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Este tipo de movimiento requiere documentación adicional
          </Typography>

          <Box display="flex" flexDirection={isMobile ? 'column' : 'row'}>
            <TextField
              inputRef={documentNumberInputRef}
              label="Número de Documento"
              variant="outlined"
              fullWidth
              value={documentNumber}
              onChange={(e) => onDocumentNumberChange(e.target.value)}
              required
              helperText="Campo obligatorio"
              style={{
                marginRight: isMobile ? 0 : theme.spacing(2),
                marginBottom: isMobile ? theme.spacing(2) : 0
              }}
              InputProps={{
                style: {
                  backgroundColor: '#ffffff'
                }
              }}
            />

            <TextField
              label="Observaciones"
              variant="outlined"
              fullWidth
              multiline
              rows={2}
              value={observations}
              onChange={(e) => onObservationsChange(e.target.value)}
              required
              helperText="Campo obligatorio"
              InputProps={{
                style: {
                  backgroundColor: '#ffffff'
                }
              }}
            />
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}